module.exports = __webpack_public_path__ + "img/hospitals.ea675b89.png";